<template>
  <div class="shipping-block-list-item-details" :class="{'errored': isBroken}">
    <span class="shipping-block-list-item-details-text">
      {{ unlinkedAddress.street }}
    </span>
    <span class="shipping-block-list-item-details-text">
      {{ $t('house') }} {{ unlinkedAddress.house }}
      <span v-if="unlinkedAddress.apartment"> , {{ $t('apartment') }} {{ unlinkedAddress.apartment }} </span>
    </span>
    <span class="shipping-block-list-item-details-text" v-if="unlinkedAddress.city || unlinkedAddress.postcode">
      {{ [unlinkedAddress.city, unlinkedAddress.postcode].filter(Boolean).join(', ') }}
    </span>
    <span class="shipping-block-list-item-details-text">
      {{ unlinkedAddress.firstname }} {{ unlinkedAddress.lastname }}
    </span>
    <span class="shipping-block-list-item-details-text">
      {{ unlinkedAddress.phone_number }}
    </span>
  </div>
</template>

<script async>
import { returnUnlinkedObject } from '@vue-storefront/core/scripts/utils/deep-parse';

export default {
  name: 'AddressCardInformation',
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  data: (vm) => ({
    unlinkedAddress: returnUnlinkedObject(vm.address)
  }),
  computed: {
    isBroken () {
      return !this.unlinkedAddress.longitude || !this.unlinkedAddress.latitude || !this.unlinkedAddress.api_details
    }
  }
}
</script>

<style lang="scss" scoped>
.shipping-block-list-item-details {
  margin-top: 10px;
  margin-left: 10px;
  padding-left: 25px;

  position: relative;

  display: flex;
  flex-direction: column;

  &:before {
    width: 15px;
    height: 18px;

    position: absolute;
    top: 0;
    left: 0;

    margin: auto;
    content: '';

    background-image: url('../../../../../../assets/account/icon-location-green.png');
    background-position: center;
    background-size: 15px 18px;
    background-repeat: no-repeat;
  }

  &.errored {
    &:before {
      width: 18px;
      background-image: url('../../../../../../assets/account/icon-attention.png');
    }
  }

  &-text {
    font-size: 14px;

    & + & {
      margin-top: 10px;
    }
  }
}
</style>
